import { Box, BoxProps, Spacer, Text, TextProps } from '@jfs/ui-new'

interface StatementListItemProps {
  transactionType: 'Debit' | 'Credit' | 'XXXX'
  transactionTime: string
  amount: string
  transactionDetails: string
  transactionId: string
}

export const StatementListItem = ({
  transactionType,
  transactionTime,
  amount,
  transactionDetails,
}: StatementListItemProps) => {
  return (
    <Box {...styles.container}>
      {transactionType !== 'XXXX' && (
        <Box flexDirection={'row'} justifyContent={'space-between'}>
          <Text fontSize={14} fontFamily="jioType-medium" color="BLACK_21">
            {transactionTime}
          </Text>
          <Text
            fontSize={14}
            fontFamily="jioType-bold"
            color={
              ['debit', 'd'].includes(transactionType?.toLowerCase()) ? 'BRAND_PRIMARY_ORANGE' : 'BRAND_PRIMARY_GREEN'
            }>
            {` ${['debit', 'd'].includes(transactionType?.toLowerCase()) ? '-' : '+'} ₹ ${amount}`}
          </Text>
        </Box>
      )}
      <Spacer size={8} />
      <Text fontSize={transactionType === 'XXXX' ? 16 : 14} fontFamily="jioType-medium" color="PRIMARY_GREY">
        {transactionDetails}
      </Text>
    </Box>
  )
}

const styles = {
  container: {
    p: 16,
    borderBottomWidth: 1,
    borderBottomColor: 'BORDER_COLOR',
  } as BoxProps,
  title: {
    fontFamily: 'jioType-bold',
    fontSize: 16,
    textAlign: 'center',
    lineHeight: 24,
  } as TextProps,
}
